<template>
  <section class="h-100" v-show="!isAuthenticated">

    <aside class="dn fl-ns w-25 w-third-l h-100 pa4 bg-blue white">
      <div class="dn db-l mb4">
        <h1 class="mv3 f1 fw7 lh-solid tr">Metsis</h1>
        <p class="ma0 f3 fw3 lh-solid tr light-gray">Projects, people and payments</p>
      </div>
    </aside>

    <main class="fl-ns w-75-ns w-two-thirds-l h-100 pa4 bl bw3 bn-ns b--blue">
      <div class="h-100 flex flex-column">
        <header class="dn-l mb4">
          <h1 class="mv3 f1 fw7 lh-solid tc">Metsis</h1>
          <p class="ma0 f3 fw3 lh-solid tc gray">Projects, people and payments</p>
        </header>
        <div class="flex flex-auto flex-column justify-center">
          <router-view></router-view>
        </div>
      </div>
    </main>

  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', ['isAuthenticated'])
  }
}
</script>

<style lang="scss" scoped>
.el-card {
  max-width: 360px;
}
</style>